import { useContext } from 'react';
import { TourContext, type TourContextValue } from './TourContext';

/** Subscribe to the active tour state. Throws when used outside a
 *  `<TourProvider>` so a forgotten provider fails loud rather than
 *  silently rendering with stale defaults. */
export function useTour(): TourContextValue {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour must be used inside <TourProvider>');
  return ctx;
}
